import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton } from './styled';

const Button = ({
  onClick,
  disabled = false,
  variant = 'default',
  thickness = 'default',
  color,
  children,
  ...props
}) => {
  return (
    <StyledButton
      onClick={onClick}
      variant={variant}
      color={color}
      thickness={thickness}
      disabled={disabled}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  variant: PropTypes.oneOf([
    'default',
    'outline',
    'outlineWithText',
    'textOnly',
    'underline',
    'transparentOutline'
  ]),
  thickness: PropTypes.oneOf(['default', 'thin']),
  color: PropTypes.string,
  disabled: PropTypes.bool
};

export default Button;
